/**
 * DataLayer component that renders markers.
 */

import React from 'react';
import {
  Marker as LeafletMarker,
  Popup as LeafletPopup,
  LayerGroup as LeafletLayerGroup
} from 'react-leaflet';
import wrapDataLayer from './Utils/Wrapper';

class MarkerLayer extends React.Component {

  constructor(props) {
    super(props);
    this.clickTrack = this.clickTrack.bind(this);
    this.getMarker = this.getMarker.bind(this);
  }

  clickTrack(event, data) {
    document.getElementById('maptool').dispatchEvent(new CustomEvent(event, { detail: data }));
  }

  /**
   * Returns a marker with or without a popup depending on properties.content
   * @param  {Object} feature Geojson Point feature
   * @return {ReactComponent} Returns a marker
   */
  getMarker(feature) {
    let popupContent = null;

    if (feature.properties.content) {
      // we want to be able to render html inside the markers.
      // Thats why we have to use the dangerouslySetInnerHTML function.
      popupContent = (
        <LeafletPopup>
          <span dangerouslySetInnerHTML={{ __html: feature.properties.content }} />
        </LeafletPopup>
      );
    } else {
      const headline = 'name' in feature.properties ? <h4>{feature.properties.name}</h4> : null;
      const description = 'description' in feature.properties ? feature.properties.description : null;

      popupContent = headline || description ? (
        <LeafletPopup>
          <a
            target='_blank'
            href={feature.properties.link}
            onClick={() => this.clickTrack('popupClick', feature.properties)}
          >
            {headline}
            <span>{description}</span>
            <span className="icon-arrow_link icon--medium pl--"></span>
          </a>
        </LeafletPopup>
      ) : null;
    }


    return (
      <LeafletMarker
        key={feature.geometry.coordinates.join('_')}
        position={[parseFloat(feature.geometry.coordinates[1]), parseFloat(feature.geometry.coordinates[0])]}
        onClick={() => this.clickTrack('popupOpen', feature.properties)}
      >
        {popupContent}
      </LeafletMarker>
    );
  }

  render() {
    const { config } = this.props;
    const markers = config.data.features.map(this.getMarker);
    return (
      <LeafletLayerGroup>
        {markers}
      </LeafletLayerGroup>
    );
  }
}

export { MarkerLayer as MarkerLayerRaw };
export default wrapDataLayer(MarkerLayer);



/** WEBPACK FOOTER **
 ** ./core_components/DataLayer/MarkerLayer.js
 **/